import { Button as ButtonUI } from '@mantine/core';
import React, { forwardRef } from 'react';
import { sendButtonClickAnalytics } from '../../analytics';

export type ButtonProps = AnalyticsProps &
  React.ComponentProps<typeof ButtonUI<'button'>> & {
    manualLoadingDuration?: number;
  };

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      analytics,
      analyticsId,
      analyticsSelectorId,
      analyticsParams,
      onClick,
      manualLoadingDuration,
      loading,
      ...props
    },
    ref
  ) => {
    function handleClick(ev: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
      onClick?.(ev);

      const sendAnalytics = analytics || analyticsId || analyticsSelectorId || analyticsParams;

      if (!sendAnalytics) {
        return;
      }

      sendButtonClickAnalytics(ev, props);
    }

    return (
      <ButtonUI
        ref={ref}
        className='Button-wrapper'
        data-testid='Button-wrapper'
        {...props}
        loading={loading}
        onClick={handleClick}
      />
    );
  }
);

Button.displayName = 'Button';

export default Button;
